import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header-component';
import { FooterComponent } from '../../shared/components/footer-component';

@Component({
  selector: 'app-candidate-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './candidate-layout.html'
})
export class CandidateLayoutComponent {

}
